var EHDI = EHDI || Object.create(null);

EHDI.ScaleManager = function(renderer, stage, type, defaultWidth, defaultHeight) {
    var resizeCallback =  arguments.length <= 5 || typeof arguments[5] === "undefined" ? null : arguments[5];
    var scaleX, scaleY, orientation, isAutoScale, center, margin, resizeClock;
    
    
    var newStyle = document.createElement("style");
    var style = "html, body {padding : 0; margin : 0; overflow : hidden; width: 100%; height: 100%, position : fixed}";
    newStyle.appendChild(document.createTextNode(style));
    document.head.appendChild(newStyle);
    
    var ratio = 1;
    var width = defaultWidth;
    var height = defaultHeight;
    
    EHDI.screen = EHDI.screen || Object.create(null);
    
    updateDeviceOrientation();
    scaleToWindow();
    
    function scaleToWindow() {
        scaleX = window.innerWidth / defaultWidth;
        scaleY = window.innerHeight / defaultHeight;
        if(type === EHDI.ScaleManager.DOCKING.WIDTH) {
            ratio = scaleX;
        } else if(type === EHDI.ScaleManager.DOCKING.HEIGHT) {
            ratio = scaleY;
        } else if(type === EHDI.ScaleManager.DOCKING.AUTO) {
            ratio = Math.min(scaleX, scaleY);
        } else if(type === EHDI.ScaleManager.DOCKING.FULLSCREEN) {
            ratio = Math.max(scaleX, scaleY);
        }
        var canvas = renderer.view;
        
        
        canvas.style.paddingLeft = 0;
        canvas.style.paddingRight = 0;
        canvas.style.paddingTop = 0;
        canvas.style.paddingBottom = 0;
        canvas.style.display = "block";
        
        width = Math.floor(defaultWidth * ratio);
        height = Math.floor(defaultHeight * ratio);
        stage.scale.x = stage.scale.y = ratio;
        if(width > window.innerWidth) {
            width = window.innerWidth;
            EHDI.screen.viewWidth = width / ratio;
        } else {
            EHDI.screen.viewWidth = window.innerWidth / ratio;
            if(EHDI.screen.viewWidth > defaultWidth) {
                EHDI.screen.viewWidth = defaultWidth;
            }
        }
        if(height > window.innerHeight) {
            height = window.innerHeight;
            EHDI.screen.viewHeight = height / ratio;
        } else {  
            EHDI.screen.viewHeight = window.innerHeight / ratio;        
            if(EHDI.screen.viewHeight > defaultHeight) {
                EHDI.screen.viewHeight = defaultHeight;
            }
        }
        
        if(EHDI.screen.centerOrigin) {
            stage.children.forEach(function(element) {
                element.position.set(EHDI.screen.viewWidth * 0.5, EHDI.screen.viewHeight * 0.5);
            });
        }
        
		EHDI.screen.xOffset = EHDI.screen.stageWidth - EHDI.screen.viewWidth;
        EHDI.screen.yOffset = EHDI.screen.stageHeight - EHDI.screen.viewHeight;
		
        renderer.resize(width, height);
        
        centerCanvas();
        window.scrollTo(0, 0);
        
		updateDeviceOrientation();
        
        if(resizeCallback) {
            resizeCallback();
        }
    };
    
    /*function scaleToWindow() {
        scaleX = canvas.parentElement.offsetWidth / canvas.offsetWidth;
        scaleY = canvas.parentElement.offsetHeight / canvas.offsetHeight;
        if(type === EHDI.ScaleManager.DOCKING.WIDTH) {
            scale = scaleX;
        } else if(type === EHDI.ScaleManager.DOCKING.HEIGHT) {
            scale = scaleY;
        } else if(type === EHDI.ScaleManager.DOCKING.AUTO) {
            scale = Math.min(scaleX, scaleY);
        } else if(type === EHDI.ScaleManager.DOCKING.FULLSCREEN) {
            scale = Math.max(scaleX, scaleY);
        }

        canvas.style.transformOrigin = "0 0";
        canvas.style.transform = "scale(" + scale + ")";

        centerCanvas();

        canvas.style.paddingLeft = 0;
        canvas.style.paddingRight = 0;
        canvas.style.paddingTop = 0;
        canvas.style.paddingBottom = 0;
        canvas.style.display = "block";
        canvas.style.overflow = "hidden";

        updateDeviceOrientation();
    };*/
    
    function updateDeviceOrientation() {
        if(window.innerHeight > window.innerWidth){
            orientation = EHDI.ScaleManager.SCREEN_ORIENTATION.PORTRAIT;
        } else {
            orientation = EHDI.ScaleManager.SCREEN_ORIENTATION.LANDSCAPE;
        }
        
        return orientation;
    };
    
    function centerCanvas() {
        var canvas = renderer.view;
        canvas.style.marginTop = 0;
        canvas.style.marginBottom = 0;
        canvas.style.marginLeft = 0;
        canvas.style.marginRight = 0;
        
        
        if (type == EHDI.ScaleManager.DOCKING.HEIGHT || type == EHDI.ScaleManager.DOCKING.FULLSCREEN || (type == EHDI.ScaleManager.DOCKING.AUTO  && width < window.innerWidth)) {
            margin = (window.innerWidth - width) / 2;
            canvas.style.marginLeft = margin + "px";
            canvas.style.marginRight = margin + "px";
        }

        //Center vertically (for wide canvases) 
        if (type == EHDI.ScaleManager.DOCKING.WIDTH || type == EHDI.ScaleManager.DOCKING.FULLSCREEN || (type == EHDI.ScaleManager.DOCKING.AUTO  && height < window.innerHeight)) {
            margin = (window.innerHeight - height) / 2;
            canvas.style.marginTop = margin + "px";
            canvas.style.marginBottom = margin + "px";
        }
    };
    /**
	 * @param (NUMBER) timeout - the scale timeout
	 */
    function addAutomaticScaling(timeout) {
       if(!isAutoScale)
            window.addEventListener("resize", function() {
                clearTimeout(resizeClock);
				timeout = timeout || 500;
                resizeClock = setTimeout(scaleToWindow, timeout);
                isAutoScale = true;
            });
    }

    function removeAutomaticScaling() {
        if(isAutoScale) {
            isAutoScale = false;
            window.removeEventListener("resize", autoScaleFunc);
        }
    }
    
    function getScale() {
        return ratio;
    }
    
    function getOrientation() {
        return orientation;
    }
    
    return {
        getScale : getScale,
        getOrientation : getOrientation,
        scaleToWindow : scaleToWindow,
        destroy: removeAutomaticScaling,
		setResizeCallback : function(callback){
			if(typeof callback !== "function") throw new Error("insert function as parameter")
			resizeCallback  = callback;
		},
        addAutomaticScaling : addAutomaticScaling
    }
};

EHDI.ScaleManager.SCREEN_ORIENTATION = {
    LANDSCAPE : 0,
    PORTRAIT : 1
}

EHDI.ScaleManager.DOCKING = {
    WIDTH: 0,
    HEIGHT: 1,
    AUTO: 2,
    FULLSCREEN : 3
}